import request from '@utils/request';
/**
 * 资讯中心文章列表
 * @param {*} data 
 * @returns 
 */
export function getNewsList(data) {
  return request({
    url: '/hycaner/officialWebsiteInformation/noAuth/front/ssh/informationList',
    method: 'get',
    params: data
  })
}
/**
 * 资讯中心文章详情
 * @param {*} data 
 * @returns 
 */
export function getNewsDetailById(data) {//id
  return request({
    url: '/hycaner/officialWebsiteInformation/noAuth/front/ssh/informationDetail',
    method: 'get',
    params: data
  })
}
